module.exports = __webpack_public_path__ + "img/pianificazione_menu_2dolist.464e3131.png";